import PoliciesEntity from './PoliciesEntity'

export default PoliciesEntity
